module.exports = __webpack_public_path__ + "assets/img/icon.d0289dc0.png";